import React, { useContext, useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../../../Auth/AuthContext'
import LayoutTable from '../../../Global/LayoutTable'
import ContentHeader from '../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { objNameRoles } from '../../../../const/constRoles'
import {
  DELETE_ROLE,
  GET_ROLES,
  EXPORT_ROLES,
} from '../../../../graphql/Catalog/Roles/roles'

export const Roles = () => {
  const { user } = useContext(AuthContext)

  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const { loading, error, data } = useQuery(GET_ROLES, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
  })
  const [dataToTable, setDataToTable] = useState([])

  useEffect(() => {
    if (!loading) {
      if (error)
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllRoles.rows.map((item) => {
        const respData = {
          id: item.id,
          Nombre: item.role_name,
          Descripcion: item.description,
          condition_show_permission_of_role__omit: item.id === 1 ? false : true,
        }

        if ([objNameRoles.master, objNameRoles.admin].includes(user.role)) {
          respData.ordenar = (
            <>
              {item.id !== 1 && (
                <Link
                  className="btn btn-migrates btn-sm mb-1"
                  to={`/orderPermissions/role/${item.id}`}
                >
                  <i className="fas fa-retweet" />
                </Link>
              )}
            </>
          )
        }

        return list.push(respData)
      })
      setDataToTable(list)
      setTotal(data.getAllRoles.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  return (
    <>
      <ContentHeader
        title="Roles de usuario"
        breadcrumb=""
        windowTitle="Roles"
      />
      <LayoutTable
        data={dataToTable}
        title="Lista de perfil de usuario"
        gql={DELETE_ROLE}
        requery={GET_ROLES}
        exportQuery={EXPORT_ROLES}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre o descripcion"
        hideDetails
      />
    </>
  )
}

export default Roles
